export default __webpack_public_path__ + "static/media/480_business02-en-mobile.c79c5384.png";